export default __webpack_public_path__ + "static/media/planet_normal.80a3463c.png";